import {
  GET_SUBSCRIPTIONS,
  CLEAR_SUBSCRIPTIONS,
  ADD_SUBSCRIPTION,
  DELETE_SUBSCRIPTION,
  SET_CURRENT,
  CLEAR_CURRENT,
  UPDATE_SUBSCRIPTION,
  FILTER_SUBSCRIPTIONS,
  CLEAR_FILTER,
  SUBSCRIPTION_ERROR,
  GET_DROPDOWNS
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case GET_SUBSCRIPTIONS:
      //console.log('subscriptionReducer', action.payload);
      return {
        ...state,
        subscriptions: action.payload.data,
        loading: false
      };
    case ADD_SUBSCRIPTION:
      return {
        ...state,
        subscriptions: [action.payload.data, ...state.subscriptions],
        loading: false
      };
    case UPDATE_SUBSCRIPTION:
      //console.log('updateSubscription', action.payload);
      return {
        ...state,
        subscriptions: state.subscriptions.map(sub => {
          if (sub.id === action.payload.data.id) {
            action.payload.data.subscribedSince = sub.subscribedSince;
            return action.payload.data;
          } else {
            return sub;
          }
        }),
        loading: false
      };
    case GET_DROPDOWNS:
      //console.log("appNames", action.payload);
      return {
        ...state,
        dropdowns: action.payload,
        loadings: false
      };
    case DELETE_SUBSCRIPTION:
      //console.log(action);
      return {
        ...state,
        subscriptions: state.subscriptions.filter(
          sub => sub.id !== action.payload
        ),
        loading: false
      };
    case CLEAR_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptions: null,
        filtered: null,
        error: null,
        current: null,
        loading: false
      };
    case SET_CURRENT:
      //console.log(`Set Current in Reducer ${JSON.stringify(action.payload)}`);
      return {
        ...state,
        current: action.payload
      };
    case CLEAR_CURRENT:
      return {
        ...state,
        current: null
      };
    case FILTER_SUBSCRIPTIONS:
      return {
        ...state,
        filtered: state.subscriptions.filter(sub => {
          const regex = new RegExp(`${action.payload}`, "gi");
          return (
            sub.appName.match(regex) ||
            sub.clientId.toString().match(regex) ||
            sub.terms.match(regex) ||
            sub.gracePeriodDays.toString().match(regex) ||
            sub.message.match(regex)
          );
        }),
        loading: false
      };
    case CLEAR_FILTER:
      return {
        ...state,
        filtered: null,
        loading: false
      };
    case SUBSCRIPTION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    default:
      return state;
  }
};
